(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecom-hero-drop"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ecom-hero-drop[data-countdown]').forEach(function(wrapper) {
    var targetDate = new Date(wrapper.getAttribute('data-countdown')).getTime();
    var countdown = wrapper.querySelector('.ecom-hero-drop__countdown');

    if (!countdown || isNaN(targetDate)) return;

    function pad(n) { return n < 10 ? '0' + n : n; }

    function tick() {
      var diff = targetDate - Date.now();

      if (diff <= 0) {
        wrapper.classList.add('ecom-hero-drop--expired');
        wrapper.classList.remove('ecom-hero-drop--has-countdown');
        return;
      }

      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      countdown.querySelector('[data-days]').textContent    = pad(days);
      countdown.querySelector('[data-hours]').textContent   = pad(hours);
      countdown.querySelector('[data-minutes]').textContent = pad(minutes);
      countdown.querySelector('[data-seconds]').textContent = pad(seconds);

      setTimeout(tick, 1000);
    }

    tick();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-advanced"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewsletterAdv(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var form = root.querySelector('[data-newsletter-form-wrapper] form');
    if (!form) return;

    var field = root.querySelector('[data-newsletter-field]');
    var input = root.querySelector('[data-newsletter-input]');
    var submitBtn = root.querySelector('[data-newsletter-submit]');
    var inlineError = root.querySelector('[data-newsletter-inline-error]');
    var consent = root.querySelector('[data-newsletter-consent]');
    var wrapper = root.querySelector('[data-newsletter-form-wrapper]');

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showInlineError(msg) {
      if (!inlineError) return;
      inlineError.textContent = msg;
      inlineError.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    function bindCopyButtons(scope) {
      var btn = scope.querySelector('[data-newsletter-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.dataset.copied = 'true';
          var original = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(function () {
            btn.textContent = original;
            btn.dataset.copied = 'false';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
        } else {
          fallbackCopy(code, done);
        }
      });
    }
    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
    bindCopyButtons(root);

    form.addEventListener('submit', function (e) {
      clearInlineError();

      var emailValue = input ? input.value.trim() : '';
      if (!emailValue || !emailRe.test(emailValue)) {
        e.preventDefault();
        showInlineError('Please enter a valid email address.');
        if (input) input.focus();
        return;
      }
      if (consent && !consent.checked) {
        e.preventDefault();
        showInlineError('Please agree to continue.');
        return;
      }

      // Progressive enhancement: try a no-reload submit. If anything goes
      // wrong, fall back to a normal form post (full page reload).
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      e.preventDefault();
      setLoading(true);

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.getElementById(root.id);
          if (!freshRoot) {
            form.submit();
            return;
          }
          var freshWrapper = freshRoot.querySelector('[data-newsletter-form-wrapper]');
          if (freshWrapper && wrapper) {
            wrapper.innerHTML = freshWrapper.innerHTML;
            var successEl = wrapper.querySelector('[data-newsletter-success]');
            var errorEl = wrapper.querySelector('[data-newsletter-error]');
            var focusTarget = successEl || errorEl;
            if (focusTarget) focusTarget.focus({ preventScroll: false });
            bindCopyButtons(wrapper);
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-newsletter-section]').forEach(initNewsletterAdv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
